module.exports = {

	methods: {
		encodeString: function(string) {
		
	      //var encodedStr = string.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
	      // return '&#'+i.charCodeAt(0)+';';
	      //});

	      var fixedstring = string;

			try{
			    // If the string is UTF-8, this will work and not throw an error.
			    fixedstring=decodeURIComponent(escape(string));
			}catch(e){
			    // If it isn't, an error will be thrown, and we can asume that we have an ISO string.
			    fixedstring=string;
			}

	      return fixedstring; 

		},

		replaceBadCharacters: function(string) {

			string = replaceAll(string, 'Ã¥', 'å')
			string = replaceAll(string, 'Ã¶', 'ö')
			string = replaceAll(string, 'Ã¤', 'ä')

			return string;

		}
	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/encoding.js